import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=aa57fdca&scoped=true&"
import script from "./addOrUpdate.vue?vue&type=script&lang=js&"
export * from "./addOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./addOrUpdate.vue?vue&type=style&index=0&id=aa57fdca&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa57fdca",
  null
  
)

export default component.exports